import api from "./api";

export const fetchEventReport = ({ data, callback }) => {
  api({
    Data: data,
    Method: "POST",
    Url: "events/export",
    Headers: {
      "Content-Type": "application/json",
    },
    ResponseType: "blob",
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const contentDisposition = response.headers["content-disposition"];
        let filename = "participantlist.xlsx"; // Default filename

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);

          if (match && match[1]) {
            // eslint-disable-next-line prefer-destructuring
            filename = match[1];
          }
        }

        callback({ isSuccess: true, data: response, filename });
      }
    },
    ResponseFailCallback: () => {
      callback({ isSuccess: false });
    },
  });
};
